import type { FacetFilters } from "@/lib/host-panel/catalog-facets";
import { hasPriceRange } from "@/lib/host-panel/catalog-facets";

/** The catalog's filter groups that are in force, by name. Never the options chosen. */
export type ActiveFilterGroup = "type" | "collection" | "material" | "price" | "featured";

const GROUP_BY_FACET: Record<string, ActiveFilterGroup> = { tipo: "type", colecao: "collection", material: "material" };

export function activeFilterGroups(filters: FacetFilters): ActiveFilterGroup[] {
  const groups = new Set<ActiveFilterGroup>();

  for (const key of filters.selection) {
    const group = GROUP_BY_FACET[key.split(":", 1)[0]];
    if (group !== undefined) groups.add(group);
  }
  if (hasPriceRange(filters.price)) groups.add("price");
  if (filters.onlyFeatured) groups.add("featured");

  return [...groups];
}
